import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';
import { useCurrentFirm } from '../hooks/queries/useLawFirms';

/**
 * AuthRedirect Component
 * Routes users to the appropriate dashboard after sign-in/sign-up
 *
 * - Attorneys (in law_firms table) → /attorney
 * - Regular users → /dashboard
 */
function AuthRedirect() {
  const navigate = useNavigate();
  const { isLoaded: userLoaded, isSignedIn, user } = useUser();
  const { data: firmData, isLoading: firmLoading, isFetched } = useCurrentFirm();

  useEffect(() => {
    // Wait for auth to load
    if (!userLoaded) return;

    // Not signed in - send to sign-in
    if (!isSignedIn) {
      navigate('/sign-in', { replace: true });
      return;
    }

    // Wait for firm check to complete
    if (firmLoading || !isFetched) return;

    // Check if user has attorney access
    if (firmData?.hasAccess) {
      navigate('/attorney', { replace: true });
    } else if (user?.publicMetadata?.source === 'quote_request') {
      // Quote-flow users (provisioned at report request, arriving via the
      // report email's magic link) land directly on Quote & Payment
      navigate('/dashboard#payments', { replace: true });
    } else {
      navigate('/dashboard', { replace: true });
    }
  }, [userLoaded, isSignedIn, firmLoading, isFetched, firmData, user, navigate]);

  return (
    <div className="auth-redirect-loading">
      <div className="loading-spinner" />
      <p>Redirecting...</p>
    </div>
  );
}

export default AuthRedirect;
